<template>
  <el-dialog
    class="rc-dialog"
    :title="msgTitle"
    :visible.sync="showPostpone.flag"
    width="50%"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
  >
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="ruleForm"
      ref="ruleForm"
      >
      <el-row>
        <el-col>
          <el-form-item label="延期状态：" prop="delayStatus" required>
            <el-radio-group v-model="ruleForm.delayStatus" v-if="selectClass.delayStatus == 1">
              <el-radio v-for="(item, i) in delayStatusData" 
                :key="i"
                :label="Number(item.paramKey)">
                {{item.paramValue}}
              </el-radio>
            </el-radio-group>
            <el-radio-group v-model="ruleForm.delayStatus" v-else>
              <el-radio v-for="(item, i) in delayStatusData"
                :key="i"
                v-show="i == 0"
                :label="Number(item.paramKey)">
                {{item.paramValue}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="培训时间：" prop="trainTime">
            <el-date-picker unlink-panels v-model="ruleForm.trainTime" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="延期记录：">
            <el-table
              ref="pageListTable"
              header-row-class-name="RCTableHeader"
              cell-class-name="RCTableCell"
              border
              :data="tableData"
              :row-style="{ color: '#51627D', fontWeight: 400 }"
              :header-cell-style="{ background: '#DCE7FA', color: '#343C4A', fontWeight: 500 }"
            >
              <el-table-column
                prop="delayStatusName"
                label="操作"
                width="100"
              >
              </el-table-column>
              <el-table-column
                prop="oldTrainTimeStr"
                label="原培训时间"
                show-overflow-tooltip
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="newTrainTimeStr"
                label="更新后培训时间"
                show-overflow-tooltip
                width="200"
              >
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">取 消</el-button>
      <el-button type="primary" @click="submit" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import moment from "moment";
import { saveClassOperationLog, classOperationLogList } from "@/api/class";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  components: {
  },
  props: {
    showPostpone: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    selectClass: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    // 培训时间校验
    let checkTrainTime = (rule, value, callback) => {
      const _this = this;
      if (new Date(value[0]).getTime() <= new Date().getTime() ) {
        callback(new Error("培训开始时间必须大于当前时间"));
      } 
      // else if (new Date(value[0]).getTime() <= new Date(_this.selectClass.enrollEndTime).getTime()) {
      //   callback(new Error("培训开始时间必须晚于报名结束时间"));
      // } 
      else if(_this.selectClass.clockEndTime) {
        if (
          moment(new Date(new Date(value[0]).getTime() + 24 * 60 * 60 * 1000)) <
          moment(_this.selectClass.clockEndTime)
        ) {
          callback(new Error("培训开始时间不能早于报到结束时间"));
        } 
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        delayStatus: 1,
        trainTime: [],
      },
      msgTitle: "设置延期",
      tableData: [],
      delayStatusData: [],
      rules: {
        delayStatus: [{ required: true, message: "请选择延期状态" }],
        trainTime: [
          { required: false, validator: checkTrainTime, trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    "selectClass.delayStatus": {
      handler(val) {
        if(val !== 1) {
          this.ruleForm.delayStatus = 1;
          this.msgTitle = "设置延期";
        } else {
          this.ruleForm.delayStatus = 2;
          this.msgTitle = "取消延期";
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getSysParamByTypes(["SELECT_DELAY_STATUS"]);
    this.classOperationLogList();
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.delayStatusData = res.data["SELECT_DELAY_STATUS"];
      });
    },
    cancel() {
      this.$emit("closePostponeModal");
    },
    classOperationLogList() {
      let params = {
        classId: this.selectClass.uuid,
      };
      classOperationLogList(params).then(({ code, data }) => {
        if (code !== 0) return;
        this.tableData = data;
      });
    },
    submit() {
      if (!this.ruleForm.delayStatus) {
        this.$message({
          message: "请选择延期状态",
          type: "error"
        });
        return;
      }
      let params = {
        ...this.ruleForm,
        classId: this.selectClass.uuid,
      };
      if (!!this.ruleForm.trainTime) {
        if (this.ruleForm.trainTime.length > 0) {
          params.newStartTime = this.ruleForm.trainTime[0];
          params.newEndTime = this.ruleForm.trainTime[1];
        }
        delete params.trainTime;
      }
      saveClassOperationLog(params).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.$emit("closePostponeModal");
        // 更新列表
        this.$parent.$refs["pagination"].search();
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    overflow: hidden;
    padding-bottom: 40px;
  }
}
</style>
